import Box from '@mui/material/Box';
import type { CSSProperties } from 'react';

interface Props {
  size?: number;
  color?: string;
  style?: CSSProperties;
  variant?: string;
}

export default function PriceSvgIcon({ size = 20, color = 'currentColor', style }: Props) {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        color,
        '& svg': {
          width: '100%',
          height: '100%',
          display: 'block'
        }
      }}
      style={style}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M21 3H3C1.346 3 0 4.346 0 6v12c0 1.654 1.346 3 3 3h18c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3ZM3 5h18c.552 0 1 .448 1 1v2H2V6c0-.552.448-1 1-1Zm18 14H3c-.552 0-1-.448-1-1v-8h20v8c0 .552-.448 1-1 1ZM6 14h5c.552 0 1 .448 1 1s-.448 1-1 1H6c-.552 0-1-.448-1-1s.448-1 1-1Zm10.5-1C14.57 13 13 14.57 13 16.5S14.57 20 16.5 20 20 18.43 20 16.5 18.43 13 16.5 13Zm0 5C15.673 18 15 17.327 15 16.5S15.673 15 16.5 15 18 15.673 18 16.5 17.327 18 16.5 18Z"
        />
      </svg>
    </Box>
  );
}
